 // This file is auto-generated don't edit it!
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { UIModule } from '../../ui.module';
import { UIButtonGroupDocsPreview } from '../../components/buttons/button-group/docs/button-group.docs.preview';
import { UIButtonGroupDocs } from '../../components/buttons/button-group/docs/generated/button-group.docs.generated';
import { UIButtonDocsPreview } from '../../components/buttons/button/docs/button.docs.preview';
import { UIButtonDocs } from '../../components/buttons/button/docs/generated/button.docs.generated';
import { UIAccordionDocsPreview } from '../../components/collapse/accordion/docs/accordion.docs.preview';
import { UIAccordionDocs } from '../../components/collapse/accordion/docs/generated/accordion.docs.generated';
import { UIAlertDialogDocsPreview } from '../../components/dialogs/alert-dialog/docs/alert-dialog.docs.preview';
import { UIAlertDialogDocs } from '../../components/dialogs/alert-dialog/docs/generated/alert-dialog.docs.generated';
import { UIConfirmDialogDocsPreview } from '../../components/dialogs/confirm-dialog/docs/confirm-dialog.docs.preview';
import { UIConfirmDialogDocs } from '../../components/dialogs/confirm-dialog/docs/generated/confirm-dialog.docs.generated';
import { UIDialogDocsPreview } from '../../components/dialogs/dialog/docs/dialog.docs.preview';
import { UIDialogDocs } from '../../components/dialogs/dialog/docs/generated/dialog.docs.generated';
import { UIErrorDialogDocsPreview } from '../../components/dialogs/error-dialog/docs/error-dialog.docs.preview';
import { UIErrorDialogDocs } from '../../components/dialogs/error-dialog/docs/generated/error-dialog.docs.generated';
import { UIFlagDocsPreview } from '../../components/icon/flag/docs/flag.docs.preview';
import { UIFlagDocs } from '../../components/icon/flag/docs/generated/flag.docs.generated';
import { UIIconDocsPreview } from '../../components/icon/icon/docs/icon.docs.preview';
import { UIIconDocs } from '../../components/icon/icon/docs/generated/icon.docs.generated';
import { UIImageDocsPreview } from '../../components/icon/image/docs/image.docs.preview';
import { UIImageDocs } from '../../components/icon/image/docs/generated/image.docs.generated';
import { UISvgIconDocsPreview } from '../../components/icon/svg-icon/docs/svg-icon.docs.preview';
import { UISvgIconDocs } from '../../components/icon/svg-icon/docs/generated/svg-icon.docs.generated';
import { UICheckboxDocsPreview } from '../../components/inputs/checkbox/docs/checkbox.docs.preview';
import { UICheckboxDocs } from '../../components/inputs/checkbox/docs/generated/checkbox.docs.generated';
import { UIDatePickerDocsPreview } from '../../components/inputs/date-picker/docs/date-picker.docs.preview';
import { UIDatePickerDocs } from '../../components/inputs/date-picker/docs/generated/date-picker.docs.generated';
import { UIInputDocsPreview } from '../../components/inputs/input/docs/input.docs.preview';
import { UIInputDocs } from '../../components/inputs/input/docs/generated/input.docs.generated';
import { UINumberInputDocsPreview } from '../../components/inputs/number/docs/number-input.docs.preview';
import { UINumberInputDocs } from '../../components/inputs/number/docs/generated/number-input.docs.generated';
import { UIRadioDocsPreview } from '../../components/inputs/radio/docs/radio.docs.preview';
import { UIRadioDocs } from '../../components/inputs/radio/docs/generated/radio.docs.generated';
import { UISelectableListDocsPreview } from '../../components/inputs/selectable-list/docs/selectable-list.docs.preview';
import { UISelectableListDocs } from '../../components/inputs/selectable-list/docs/generated/selectable-list.docs.generated';
import { UITextareaDocsPreview } from '../../components/inputs/textarea/docs/textarea.docs.preview';
import { UITextareaDocs } from '../../components/inputs/textarea/docs/generated/textarea.docs.generated';
import { UIToggleSwitchDocsPreview } from '../../components/inputs/toggle-switch/docs/toggle-switch.docs.preview';
import { UIToggleSwitchDocs } from '../../components/inputs/toggle-switch/docs/generated/toggle-switch.docs.generated';
import { UIListDocsPreview } from '../../components/layout/list/docs/list.docs.preview';
import { UIListDocs } from '../../components/layout/list/docs/generated/list.docs.generated';
import { UIPanelDocsPreview } from '../../components/layout/panel/docs/panel.docs.preview';
import { UIPanelDocs } from '../../components/layout/panel/docs/generated/panel.docs.generated';
import { UILoaderDocsPreview } from '../../components/loader/loader/docs/loader.docs.preview';
import { UILoaderDocs } from '../../components/loader/loader/docs/generated/loader.docs.generated';
import { UIBreadcrumbsDocsPreview } from '../../components/navigation/breadcrumbs/docs/breadcrumbs.docs.preview';
import { UIBreadcrumbsDocs } from '../../components/navigation/breadcrumbs/docs/generated/breadcrumbs.docs.generated';
import { UINotificationDocsPreview } from '../../components/notification/notification/docs/notification.docs.preview';
import { UINotificationDocs } from '../../components/notification/notification/docs/generated/notification.docs.generated';
import { UIDropdownDocsPreview } from '../../components/popovers/dropdown/docs/dropdown.docs.preview';
import { UIDropdownDocs } from '../../components/popovers/dropdown/docs/generated/dropdown.docs.generated';
import { UIPopoverDocsPreview } from '../../components/popovers/popover/docs/popover.docs.preview';
import { UIPopoverDocs } from '../../components/popovers/popover/docs/generated/popover.docs.generated';
import { UITooltipDocsPreview } from '../../components/popovers/tooltip/docs/tooltip.docs.preview';
import { UITooltipDocs } from '../../components/popovers/tooltip/docs/generated/tooltip.docs.generated';
import { UISelectDocsPreviewComponent } from '../../components/select/select/docs/select.docs.preview';
import { UISelectDocs } from '../../components/select/select/docs/generated/select.docs.generated';
import { UIHelpMenuDocsPreviewComponent } from '../../components/static/help-menu/docs/help-menu.docs.preview';
import { UIHelpMenuDocs } from '../../components/static/help-menu/docs/generated/help-menu.docs.generated';

@NgModule({
    imports: [
        UIModule,
        BrowserModule,
        CommonModule,
        FormsModule,
        ReactiveFormsModule
    ],
    declarations: [
        UIButtonGroupDocsPreview,
        UIButtonGroupDocs,
        UIButtonDocsPreview,
        UIButtonDocs,
        UIAccordionDocsPreview,
        UIAccordionDocs,
        UIAlertDialogDocsPreview,
        UIAlertDialogDocs,
        UIConfirmDialogDocsPreview,
        UIConfirmDialogDocs,
        UIDialogDocsPreview,
        UIDialogDocs,
        UIErrorDialogDocsPreview,
        UIErrorDialogDocs,
        UIFlagDocsPreview,
        UIFlagDocs,
        UIIconDocsPreview,
        UIIconDocs,
        UIImageDocsPreview,
        UIImageDocs,
        UISvgIconDocsPreview,
        UISvgIconDocs,
        UICheckboxDocsPreview,
        UICheckboxDocs,
        UIDatePickerDocsPreview,
        UIDatePickerDocs,
        UIInputDocsPreview,
        UIInputDocs,
        UINumberInputDocsPreview,
        UINumberInputDocs,
        UIRadioDocsPreview,
        UIRadioDocs,
        UISelectableListDocsPreview,
        UISelectableListDocs,
        UITextareaDocsPreview,
        UITextareaDocs,
        UIToggleSwitchDocsPreview,
        UIToggleSwitchDocs,
        UIListDocsPreview,
        UIListDocs,
        UIPanelDocsPreview,
        UIPanelDocs,
        UILoaderDocsPreview,
        UILoaderDocs,
        UIBreadcrumbsDocsPreview,
        UIBreadcrumbsDocs,
        UINotificationDocsPreview,
        UINotificationDocs,
        UIDropdownDocsPreview,
        UIDropdownDocs,
        UIPopoverDocsPreview,
        UIPopoverDocs,
        UITooltipDocsPreview,
        UITooltipDocs,
        UISelectDocsPreviewComponent,
        UISelectDocs,
        UIHelpMenuDocsPreviewComponent,
        UIHelpMenuDocs
    ],
    exports: [
        UIButtonGroupDocsPreview,
        UIButtonGroupDocs,
        UIButtonDocsPreview,
        UIButtonDocs,
        UIAccordionDocsPreview,
        UIAccordionDocs,
        UIAlertDialogDocsPreview,
        UIAlertDialogDocs,
        UIConfirmDialogDocsPreview,
        UIConfirmDialogDocs,
        UIDialogDocsPreview,
        UIDialogDocs,
        UIErrorDialogDocsPreview,
        UIErrorDialogDocs,
        UIFlagDocsPreview,
        UIFlagDocs,
        UIIconDocsPreview,
        UIIconDocs,
        UIImageDocsPreview,
        UIImageDocs,
        UISvgIconDocsPreview,
        UISvgIconDocs,
        UICheckboxDocsPreview,
        UICheckboxDocs,
        UIDatePickerDocsPreview,
        UIDatePickerDocs,
        UIInputDocsPreview,
        UIInputDocs,
        UINumberInputDocsPreview,
        UINumberInputDocs,
        UIRadioDocsPreview,
        UIRadioDocs,
        UISelectableListDocsPreview,
        UISelectableListDocs,
        UITextareaDocsPreview,
        UITextareaDocs,
        UIToggleSwitchDocsPreview,
        UIToggleSwitchDocs,
        UIListDocsPreview,
        UIListDocs,
        UIPanelDocsPreview,
        UIPanelDocs,
        UILoaderDocsPreview,
        UILoaderDocs,
        UIBreadcrumbsDocsPreview,
        UIBreadcrumbsDocs,
        UINotificationDocsPreview,
        UINotificationDocs,
        UIDropdownDocsPreview,
        UIDropdownDocs,
        UIPopoverDocsPreview,
        UIPopoverDocs,
        UITooltipDocsPreview,
        UITooltipDocs,
        UISelectDocsPreviewComponent,
        UISelectDocs,
        UIHelpMenuDocsPreviewComponent,
        UIHelpMenuDocs
    ],
})
export class UIDocsModule { }
